import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import DOMPurify from 'dompurify';
import { Popover } from '@mui/material';
import { ExpandableText, TextToolTip } from 'components';
import { CustomDeleteModal } from 'fragments';
import { PayableNotes } from './payableNotes';
import { payableNotesColors, payableNotesPriorities } from './constants';
import { Images, PermissionsList, RolePermission, useModal, useSecondaryModal } from 'utils';
import { loadActions } from 'store';

const DELETE_ACTION_TYPE = 'DELETE_PAYABLE_NOTE';

export const PayableNoteCell = ({ load, handleAddNote }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const { open } = useModal();
  const { openSecondary, closeSecondary } = useSecondaryModal();
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover1' : undefined;

  const sortedNotes = [...load?.payable?.pNotes || []].sort((a, b) => {
    const priorityA = payableNotesPriorities.indexOf(a.urgency);
    const priorityB = payableNotesPriorities.indexOf(b.urgency);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    return moment(a.createdDate).isAfter(moment(b.createdDate)) ? -1 : 1;
  });



  const latest = (load?.payable?.pNotes || []).reduce((latestItem, currentItem) => {
    if (!latestItem) return currentItem;

    const latestPriority = payableNotesPriorities.indexOf(latestItem.urgency);
    const currentPriority = payableNotesPriorities.indexOf(currentItem.urgency);

    if (currentPriority < latestPriority) {
      return currentItem;
    }

    if (currentPriority === latestPriority) {
      return moment(currentItem.createdDate).isAfter(moment(latestItem.createdDate))
        ? currentItem
        : latestItem;
    }

    return latestItem;
  }, null);


  const cleanHtml = DOMPurify.sanitize(latest?.text || '');

  const toggleSettings = (event) => {
    setAnchorEl(event ? event.currentTarget : null);
  };


  return (
    <div className='payable-note-cell-wrapper'>
      {!!latest ?
        <div
          className='payable-note-cell-block'
          onClick={toggleSettings}
        >
          <div
            className='payable-note-around-block'
            style={{ background: payableNotesColors?.[latest?.urgency]?.circleColor }}
          />

          <TextToolTip
            text={<span dangerouslySetInnerHTML={{ __html: cleanHtml }} />}
            content={<span dangerouslySetInnerHTML={{ __html: cleanHtml }} />}
            wrapperStyles={{
              width: 'fit-content',
            }}
            textStyles={{
              width: 'fit-content',
            }}
          />
          {!!sortedNotes?.length &&
            <div className='payable-note-cell-count'>
              +{sortedNotes?.length}
            </div>
          }

          {/*{RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.MANAGE_PAYABLE_NOTES?.code]) &&*/}
          {/*  <div className='payable-note-cell-actions' style={{ marginLeft: 'auto' }}>*/}
          {/*    <button*/}
          {/*      className='reset-btn'*/}
          {/*      style={{ padding: '4px' }}*/}
          {/*      onClick={(e) => {*/}
          {/*        e.stopPropagation();*/}
          {/*        open(*/}
          {/*          <PayableNotes*/}
          {/*            item={latest}*/}
          {/*            load={load}*/}
          {/*          />,*/}
          {/*          { noPadding: true, noCloseButton: true },*/}
          {/*        );*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <img src={Images.edit} alt='edit' />*/}
          {/*    </button>*/}

          {/*    <button*/}
          {/*      className='reset-btn'*/}
          {/*      style={{ padding: '4px 5.91px 4px 5px' }}*/}
          {/*      onClick={(e) => {*/}
          {/*        e.stopPropagation();*/}

          {/*        openSecondary(*/}
          {/*          <CustomDeleteModal*/}
          {/*            afterSuccess={() => {*/}
          {/*              closeSecondary();*/}
          {/*            }}*/}
          {/*            actionType={DELETE_ACTION_TYPE}*/}
          {/*            text='Delete note?'*/}
          {/*            info={'Note'}*/}
          {/*            closeModal={closeSecondary}*/}
          {/*            handleDel={() => dispatch(loadActions.deletePayableNote(load?.id, latest?.id))}*/}
          {/*          />,*/}
          {/*        );*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <img src={Images.redTrash} alt='delete' />*/}
          {/*    </button>*/}
          {/*  </div>*/}
          {/*}*/}
        </div>
        :
        RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.MANAGE_PAYABLE_NOTES?.code]) ?
          <button
            onClick={() => {
              handleAddNote(load);
            }}
            className='blue-btn-with-circle'
            style={{ textDecoration: 'underline' }}
          >
            Add Note
          </button>
          : '---'
      }

      <Popover
        id={id}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={() => toggleSettings()}
        className='payables-notes-popover-wrapper'
        classes={{
          paper: 'payables-notes-popper',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className='payables-notes-popper-header'>
          {!!sortedNotes?.length &&
            <p className='payables-notes-popover-title'>
              {sortedNotes?.length} notes
            </p>
          }
          {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.MANAGE_PAYABLE_NOTES?.code]) &&
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleSettings();
                handleAddNote(load);
              }}
              className='blue-btn-with-circle'
            >
              <img src={Images.addPlusBlueCircle} alt='add' />
              <span>Add More</span>
            </button>
          }
        </div>

        <div className='payables-notes-popper-body'>
          {sortedNotes?.map((item, index) => {
            const formattedDate = moment(item?.createdDate).format('MM/DD/YY');
            const formattedTime = moment(item?.createdDate).format('hh:mm A');

            return (
              <div className='payables-notes-card-wrapper' key={index}>
                <div className='align-justify-center'
                     style={{ gap: 8, paddingBottom: 8, borderBottom: '1px solid #E6ECF3' }}>
                  <div
                    className='payable-note-around-block'
                    style={{ background: payableNotesColors[item?.urgency]?.circleColor }}
                  />
                  {item?.text &&
                    <ExpandableText htmlContent={item?.text} />
                  }
                </div>

                <div className='payables-notes-card-info'>
                  <TextToolTip
                    classNameText='payables-notes-card-info-text'
                    content={`Date: ${formattedDate} Time: ${formattedTime}`}
                    text={<p>Date: <span>{formattedDate}</span> Time: <span>{formattedTime}</span></p>}
                    wrapperStyles={{
                      width: 'fit-content',
                    }}
                  />

                  {item?.creatorName &&
                    <TextToolTip
                      classNameText='payables-notes-card-info-text'
                      content={item?.creatorName}
                      text={item?.creatorName}
                      wrapperStyles={{
                        width: 'fit-content',
                      }}
                    />
                  }

                  {RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.MANAGE_PAYABLE_NOTES?.code]) &&
                    <div className='payables-notes-card-actions' style={{ marginLeft: 'auto' }}>
                      <button
                        className='reset-btn'
                        style={{ padding: '4px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSettings();
                          open(
                            <PayableNotes
                              item={item}
                              load={load}
                            />,
                            { noPadding: true, noCloseButton: true },
                          );
                        }}
                      >
                        <img src={Images.edit} alt='edit' />
                      </button>

                      <button
                        className='reset-btn'
                        style={{ padding: '4px 5.91px 4px 5px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleSettings();
                          openSecondary(
                            <CustomDeleteModal
                              afterSuccess={() => {
                                closeSecondary();
                              }}
                              actionType={DELETE_ACTION_TYPE}
                              text='Delete note?'
                              info={'Note'}
                              closeModal={closeSecondary}
                              handleDel={() => dispatch(loadActions.deletePayableNote(load?.id, latest?.id))}
                            />,
                          );
                        }}
                      >
                        <img src={Images.redTrash} alt='delete' />
                      </button>
                    </div>
                  }
                </div>
              </div>
            );
          })}
        </div>
      </Popover>
    </div>
  );
};

